// eslint-disable-next-line max-classes-per-file
import { Serializable, jsonProperty } from "ts-serializable"

class BrandCallStatus extends Serializable {
  @jsonProperty(String, null)
  codResult = ""

  @jsonProperty(String, null)
  descResult = ""
}

class BrandDetail extends Serializable {
  @jsonProperty(String, null)
  codMarca = ""

  @jsonProperty(String, null)
  descMarca = ""

  @jsonProperty(String, null)
  desMarca = ""

  @jsonProperty(String, null)
  codMarcaApeseg = ""

  @jsonProperty(String, null)
  codMarcaApeSeg = ""
}

class Brands extends Serializable {
  @jsonProperty(BrandCallStatus, null)
  resultado: BrandCallStatus | any = new BrandCallStatus()

  @jsonProperty([BrandDetail], null)
  marcas: Array<BrandDetail> = []
}

export { Brands, BrandDetail, BrandCallStatus }
